<template>
  <div 
    v-if="showPagination" 
    class="d-flex justify-content-center"
    style="margin-bottom: 10px; margin-top: 30px"
  >
    <div class="d-flex align-middle" v-if="showFirstPage">
      <button class="pagination-btn" @click="$emit('go-to-page', 1)">
        <i class="fa-solid fa-angles-left"></i>
      </button>
    </div>
    
    <div class="d-flex align-middle pagination-spacing" v-if="hasPrevPage">
      <button class="pagination-btn" @click="$emit('prev-page')">
        <i class="fa-solid fa-angle-left"></i>
      </button>
    </div>
    
    <div class="d-flex align-middle pagination-spacing">
      <button 
        class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8" 
        @click="$emit('go-to-page', currentPage)"
      >
        {{ currentPage }}
      </button>
    </div>
    
    <div class="d-flex align-middle pagination-spacing" v-if="hasNextPage">
      <button class="pagination-btn" @click="$emit('next-page')">
        <i class="fa-solid fa-angle-right"></i>
      </button>
    </div>
    
    <div class="d-flex align-middle pagination-spacing" v-if="showLastPage">
      <button class="pagination-btn" @click="$emit('go-to-page', lastPage)">
        <i class="fa-solid fa-angles-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoursePagination',
  
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    lastPage: {
      type: Number,
      default: -1
    },
    showPagination: {
      type: Boolean,
      default: false
    },
    showFirstPage: {
      type: Boolean,
      default: false
    },
    showLastPage: {
      type: Boolean,
      default: false
    },
    hasNextPage: {
      type: Boolean,
      default: false
    },
    hasPrevPage: {
      type: Boolean,
      default: false
    }
  },
  
  emits: ['go-to-page', 'next-page', 'prev-page']
}
</script>

<style scoped>
.pagination-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px 12px;
  color: #1A0054;
}

.pagination-btn:hover {
  background-color: #f8f9fa;
  border-radius: 4px;
}

.pagination-spacing {
  margin-left: 10px;
}
</style>